module.exports = __webpack_public_path__ + "static/media/small_balancing_tube_st.4eba74ed.svg";